var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdge = function SvgEdge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6615 17.8625C21.346 18.0279 21.0164 18.1759 20.674 18.3045C19.6445 18.6912 18.5076 18.9105 17.3084 18.9105C12.872 18.9105 9.00746 15.8587 9.00746 11.9427C9.00746 10.8416 9.64451 9.88715 10.5473 9.3844C6.53529 9.5526 5.50391 13.7344 5.50391 16.1842C5.50391 23.1097 11.8873 23.8126 13.2627 23.8126C14.004 23.8126 15.1228 23.5967 15.7968 23.3852C15.8379 23.3715 15.8788 23.3578 15.9197 23.3437C18.5222 22.4462 20.7186 20.6805 22.1624 18.3918C22.3694 18.0635 22.0053 17.6822 21.6615 17.8625Z",
    fill: "url(#edge_svg__paint0_linear_20_7689)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M21.6615 17.8625C21.346 18.0279 21.0164 18.1759 20.674 18.3045C19.6445 18.6912 18.5076 18.9105 17.3084 18.9105C12.872 18.9105 9.00746 15.8587 9.00746 11.9427C9.00746 10.8416 9.64451 9.88715 10.5473 9.3844C6.53529 9.5526 5.50391 13.7344 5.50391 16.1842C5.50391 23.1097 11.8873 23.8126 13.2627 23.8126C14.004 23.8126 15.1228 23.5967 15.7968 23.3852C15.8379 23.3715 15.8788 23.3578 15.9197 23.3437C18.5222 22.4462 20.7186 20.6805 22.1624 18.3918C22.3694 18.0635 22.0053 17.6822 21.6615 17.8625Z",
    fill: "url(#edge_svg__paint1_radial_20_7689)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91042 22.6325C9.07657 22.1157 8.35272 21.4341 7.77898 20.6286C6.89117 19.3821 6.3604 17.8489 6.3604 16.1842C6.3604 13.7344 7.50111 11.5646 9.25945 10.1899C9.6588 9.87766 10.1701 9.56274 10.5469 9.38441C10.8394 9.24592 11.3397 8.99654 12.0042 9.00596C13.106 9.02158 13.9384 9.58325 14.4122 10.2212C14.7763 10.7113 15.0008 11.3152 15.0083 11.9707C15.0085 11.9509 17.3018 4.50775 7.50368 4.50775C3.38871 4.50775 0 8.41426 0 11.8404C0 14.0137 0.504312 15.7489 1.13574 17.0935C2.54205 20.0888 5.14992 22.4071 8.34003 23.4285C9.49532 23.7984 10.726 24 12.0042 24C13.3299 24 14.604 23.7819 15.7964 23.3852C15.1223 23.5967 14.4076 23.7124 13.6664 23.7124C12.291 23.7124 11.009 23.3135 9.91042 22.6325Z",
    fill: "url(#edge_svg__paint2_linear_20_7689)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M9.91042 22.6325C9.07657 22.1157 8.35272 21.4341 7.77898 20.6286C6.89117 19.3821 6.3604 17.8489 6.3604 16.1842C6.3604 13.7344 7.50111 11.5646 9.25945 10.1899C9.6588 9.87766 10.1701 9.56274 10.5469 9.38441C10.8394 9.24592 11.3397 8.99654 12.0042 9.00596C13.106 9.02158 13.9384 9.58325 14.4122 10.2212C14.7763 10.7113 15.0008 11.3152 15.0083 11.9707C15.0085 11.9509 17.3018 4.50775 7.50368 4.50775C3.38871 4.50775 0 8.41426 0 11.8404C0 14.0137 0.504312 15.7489 1.13574 17.0935C2.54205 20.0888 5.14992 22.4071 8.34003 23.4285C9.49532 23.7984 10.726 24 12.0042 24C13.3299 24 14.604 23.7819 15.7964 23.3852C15.1223 23.5967 14.4076 23.7124 13.6664 23.7124C12.291 23.7124 11.009 23.3135 9.91042 22.6325Z",
    fill: "url(#edge_svg__paint3_radial_20_7689)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2799 13.9554C14.2039 14.0538 13.9702 14.1896 13.9702 14.4864C13.9702 14.7305 14.1296 14.9661 14.4128 15.1638C15.761 16.1047 18.3021 15.9779 18.3089 15.9779C19.358 15.9742 20.3017 15.6858 21.147 15.1916C21.5316 14.9667 21.8876 14.6996 22.2085 14.3947C23.3098 13.3481 23.9812 11.8733 23.9999 10.2347C24.0238 8.13326 23.2536 6.73619 22.9371 6.11757C20.9502 2.23462 16.6615 0 11.9984 0C5.42513 0 0.0891841 5.28245 0.000976562 11.8313C0.0455378 8.40538 3.45039 5.63893 7.49778 5.63893C7.82595 5.63893 9.69733 5.67094 11.4358 6.58332C12.9671 7.38701 13.77 8.35816 14.328 9.32155C14.9074 10.3218 15.0105 11.5852 15.0105 12.0889C15.0105 12.5927 14.7565 13.3384 14.2799 13.9554Z",
    fill: "url(#edge_svg__paint4_radial_20_7689)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2799 13.9554C14.2039 14.0538 13.9702 14.1896 13.9702 14.4864C13.9702 14.7305 14.1296 14.9661 14.4128 15.1638C15.761 16.1047 18.3021 15.9779 18.3089 15.9779C19.358 15.9742 20.3017 15.6858 21.147 15.1916C21.5316 14.9667 21.8876 14.6996 22.2085 14.3947C23.3098 13.3481 23.9812 11.8733 23.9999 10.2347C24.0238 8.13326 23.2536 6.73619 22.9371 6.11757C20.9502 2.23462 16.6615 0 11.9984 0C5.42513 0 0.0891841 5.28245 0.000976562 11.8313C0.0455378 8.40538 3.45039 5.63893 7.49778 5.63893C7.82595 5.63893 9.69733 5.67094 11.4358 6.58332C12.9671 7.38701 13.77 8.35816 14.328 9.32155C14.9074 10.3218 15.0105 11.5852 15.0105 12.0889C15.0105 12.5927 14.7565 13.3384 14.2799 13.9554Z",
    fill: "url(#edge_svg__paint5_radial_20_7689)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "edge_svg__paint0_linear_20_7689",
    x1: 5.50391,
    y1: 23.8126,
    x2: 22.2228,
    y2: 23.8126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C59A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#114A8B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "edge_svg__paint1_radial_20_7689",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.7384 16.7234) scale(8.94225 7.71702)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.71659,
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9459,
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edge_svg__paint2_linear_20_7689",
    x1: 9.70861,
    y1: 2.90199,
    x2: -2.5824,
    y2: 11.6942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B9DE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16164,
    stopColor: "#1595DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66749,
    stopColor: "#0680D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078D4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "edge_svg__paint3_radial_20_7689",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.68483 18.6247) rotate(-81.464) scale(13.4283 11.0075)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.76293,
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9459,
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "edge_svg__paint4_radial_20_7689",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.36612 4.388) rotate(92.129) scale(18.978 28.4736)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35C1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11079,
    stopColor: "#34C1ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23164,
    stopColor: "#2FC2DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31446,
    stopColor: "#2BC3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67338,
    stopColor: "#36C752"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "edge_svg__paint5_radial_20_7689",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.7319 7.27263) rotate(73.6747) scale(9.12542 13.0994)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66EB6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66EB6E",
    stopOpacity: 0.01
  })))));
};
export default SvgEdge;